import React from "react";
import PropTypes from "prop-types";

import SvgIcon from "components/base/SvgIcon";
import { cn } from "utils";

const Chip = ({
  value,
  isActive,
  className,
  onClose,
  onClick,
  readOnly,
  id,
}) => (
  <div
    id={id}
    className={cn(
      "flex items-center max-w-full text-sm border border-blue-300 text-blue-300 rounded-full whitespace-nowrap transition-all",
      {
        "bg-blue-300 text-white": isActive && !readOnly,
        "pr-1.5": isActive && onClose,
        "hover:shadow": onClick,
        "!bg-gray-200 !text-gray-400 !border-none pr-1.5": readOnly,
      },
      className
    )}
  >
    <button
      onClick={onClick}
      className={cn("px-2 overflow-hidden text-ellipsis", {
        "cursor-pointer": !!onClick && !readOnly,
        "cursor-default": !onClick,
      })}
    >
      {value}
    </button>

    {onClose && isActive && !readOnly && (
      <button className="shrink-0" type="button" onClick={onClose}>
        <SvgIcon type="xmark" className="w-2" />
      </button>
    )}
  </div>
);

Chip.propTypes = {
  value: PropTypes.any.isRequired,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  readOnly: PropTypes.bool,
};

Chip.defaultProps = {
  isActive: false,
  className: "",
  onClose: null,
  onClick: null,
  readOnly: false,
};

export default Chip;
